import { Controller } from "@hotwired/stimulus"
import { harvestExperimentEvent } from "@/common/harvester"
import { pushToDataLayer, objEmpty } from "@/common/util"

export default class extends Controller {
  static values = {
    purchaseParams: {},
    quoteFormParams: {},
    harvestExperimentParams: Array,
  }

  declare purchaseParamsValue: Record<string, unknown>
  declare hasPurchaseParamsValue: boolean

  declare quoteFormParamsValue: Record<string, unknown>
  declare hasQuoteFormParamsValue: boolean

  declare harvestExperimentParamsValue: Array<{
    experiment_id: string
    variation_id: string
    action: string
    order_id?: number
  }>
  declare hasHarvestExperimentParamsValue: boolean

  connect() {
    if (this.hasPurchaseParamsValue) {
      pushToDataLayer(this.purchaseParamsValue)

      if (this.hasHarvestExperimentParamsValue) {
        for (const { experiment_id, variation_id, action, order_id } of this.harvestExperimentParamsValue) {
          if (experiment_id && variation_id && action) {
            harvestExperimentEvent(experiment_id, variation_id, action, order_id)
          }
        }
      }
    }

    if (this.hasQuoteFormParamsValue && !objEmpty(this.quoteFormParamsValue)) {
      pushToDataLayer(this.quoteFormParamsValue)
    }
  }
}
